import atm_table from 'assets/images/table/atm_table.png';

export const services = {
  atm: {
    about: {
      title: `About`,
      description: `<p>A self-serve banking facility that allows you to perform fund transfer, bill payment, and more using your alrajhi bank Malaysia Debit Card-i and a Personal Identification Number (PIN)</p>
      <br/>
      Service availability: From 06:00AM to 11:59PM
      `,
    },
    accordion: [
      {
        title: `You may perform your-self service banking transactions outside regular banking hours as follows:`,
        content: (
          <ul className="text-grey-color">
            <li>Balance inquiry on your Al Rajhi Bank Account(s)</li>
            <li>ATM cash withdrawal</li>
            <li>Funds transfer between Al Rajhi Bank accounts</li>
            <li>Funds transfer to third party accounts.</li>
            <li>Instant transfer (IBFT) to other banks via MEPS network</li>
            <li>Al Rajhi Bank charge card payment</li>
            <li>Cheque book order</li>
            <li>ATM PIN change</li>
            <li>Internet Banking (alrajhi@24seven.com) application – request a temporary PIN to sign up as a registered alrajhi@24seven user.</li>
            <li>Request a temporary PIN to sign-up as a Phone Banking user</li>
            <li>
              Change your preferred ATM limit:
              <ul>
                <li>ATM cash withdrawal limit – up to a maximum of RM5,000 per day</li>
                <li>ATM transfer limit – up to RM30,000 per day (a combination limit with instant transfer)</li>
                <li>purchase limit (i.e. purchase at POS terminal)</li>
                <li>internet purchase transaction limit</li>
              </ul>
            </li>
            <li>
              Activation of overseas transaction:
              <ul>
                <li>Please contact Customer Care at +603 2332 6000 for enquiries and activation</li>
              </ul>
            </li>
          </ul>
        ),
      },
      {
        title: `Acceptance of Other Card Type:`,
        content: (
          <div className="text-grey-color">
            <div className="mb-4">alrajhi bank Malaysia ATM accepts other cards to perform transaction as follows:</div>
            <img src={atm_table} alt='atm_table' width="100%" />
          </div>
        )
      },
      {
        title: `Eligibility:`,
        content: (
          <ul className="text-grey-color">
            <li>Al Rajhi Bank ATM / Debit cardholders</li>
            <li>Al Rajhi Bank Debit Platinum cardholders</li>
            <li>Al Rajhi Bank charge cardholders</li>
          </ul>
        )
      }
    ],
    importantNotice: {
      title: `Important Notice`,
      description: `
        <ul className="text-grey-color">
          <li className="mb-3">If your card has been lost or stolen, please report immediately to: <strong>Al Rajhi Bank Customer Care Consultant (24 hour daily), call <span className="primary-color">+603 2332 6000</span> (domestic) or <span className="primary-color">+603 2332 9000</span> (International).</strong></li>
          <li className="my-3">Remember to activate your <strong>Al Rajhi Bank Debit Card-i / Rafahia Debit Card-i</strong> by calling <strong>Al Rajhi Bank Customer Care Consultant (24 hour daily) at <span className="primary-color">+603 2332 6000</span> (domestic)</strong> before you leave the country.</li>
          <li className="my-3">You can spend more locally by increasing your “Daily Purchase Limit” at any POS terminal by visiting any Al Rajhi Bank ATM or nearest branch by changing <strong>the "Purchase Limit"</strong> flag.</li>
        </ul>
      `
    }
  },
  mepsAtm: {
    about: {
      title: `About`,
      description: `<p>A self-serve banking facility provided by Payments Network Malaysia (PayNet) that allows you to perform cash withdrawal, balance inquiry and instant transfer using your Al Rajhi Bank Debit Card-i and a Personal Identification Number (PIN) at MEPS ATM.</p>
      <br/>
      Service availability: Operates 24-hours a day, 7-days a week
      `,
    },
    accordion: [
      {
        title: `Services`,
        content: (
          <ul className="text-grey-color">
            <li>
              Al Rajhi Bank is now a member of MEPS ATM Network, providing you the convenience of banking with us. You can now access your Al Rajhi Bank deposits accounts using Al Rajhi Bank Debit Card-i at over 600 MEPS ATMs in Malaysia to perform the following services:
              <ul>
                <li>Balance enquiry</li>
                <li>Interbank cash withdrawal</li>
                <li>Interbank ATM instant transfer to current account and savings account, financing and cards repayment.</li>
              </ul>
            </li>
            <li>No more payment delays! All transactions are performed in real-time</li>
          </ul>
        ),
      },
    ],
  },
  chequeDeposit: {
    about: {
      title: `About`,
      description: `<p>A self-service banking facility that allows you to deposit into your Al Rajhi Bank Savings / Current Account-i using our cheque deposit facility.</p>`,
    },
    accordion: [
      {
        title: `Two (2) methods to perform your cheque deposit for your convenience:`,
        content: (
          <ol className="text-grey-color">
            <li>
              <strong>Fascek Box</strong>
              <ul>
                <li>No cheque deposit envelopes are required for this Fascek Box.</li>
                <li>A receipt will be printed after dropping your cheque as confirmation of receipt.</li>
              </ul>
            </li>
            <li>
              <strong>Cheque Drop Box</strong>
              <ul>
                <li>No cheque deposit envelopes are required.</li>
                <li>Just 'Drop and Go'.</li>
              </ul>
            </li>
          </ol>
        ),
      },
    ],
  },
  smsNotificationAlerts: {
    about: {
      title: `About`,
      description: `<p>Stay connected with Al Rajhi Bank account through our SMS Alert Facility.</p>`,
    },
    whatIs: {
      title: `What is SMS Notification Alerts:`,
      description: `
      <p>The SMS notification alerts is a service to keep you updated on your banking transaction details by sending alerts to your registered mobile number.</p>
      <br />
      You will be receiving instant SMS alerts when you perform the following transactions:
      `,
    },
    transferPayment: {
      title: `Funds Transfers & Payment Alerts:`,
      description: `
      <ul>
        <li>Add / Set Beneficiary.</li>
        <li>Funds Transfer to Other Al Rajhi Account.</li>
        <li>Interbank GIRO (IBG) Funds Transfer to Other Bank Account</li>
        <li>JomPAY - Single Bill Payments</li>
        <li>JomPAY - Multiple Bill Payments</li>
        <li>Increase Transfer & Payment Limits.</li>
      </ul>
      `,
    },
    purpose: {
      title: `Purpose:`,
      description: `
      <p>The SMS alert service is just one of the ways we provide you with greater assurance when you bank with us. Once you register your mobile phone number at the nearest Al Rajhi Bank Branch, you will receive an SMS alert informing you of the transaction type, amount, status, date and time each time you perform the following "Successful" or "Accepted" online transactions:</p>
      `,
    },
    serviceFee: {
      title: `Service Fee:`,
      description: `
      <p>Free (for a limited period)</p>
      `,
    },
    sample: {
      title: `Sample Details of SMS Notification Alerts:`,
      description: `
      <p>RM0.00 Al Rajhi Bank: Immediate Funds Transfer 500.00 MYR To Interbank Giro (IBG) – Accepted 04/10/2016 06:13:56. Did not authorize, call 1300826000</p>
      `,
    },
    availabilty: {
      title: `Service availability:`,
      description: `
      <p>The SMS notification alert service is available to all local mobile network e.g. 010, 012, 019, 013, 016, 017 and 018 subscribers so long as the mobile number is registered at Al Rajhi Bank branch.</p>
      `,
    },
    howToApply: {
      title: `How to apply:`,
      description: `
      <p>
        New Customer:
        <ul>
          <li>Ensure that your mobile phone number is registered by Al Rajhi Bank Officer during the account opening.</li>
        </ul>
      </p>
      <p>
        Existing Customer:
        <ul>
          <li>If you have already registered, please make sure you have updated your mobile number at the nearest Al Rajhi Bank branch.</li>
        </ul>
      </p>
      `
    },
  },
  serviceRequest: {
    about: {
      title: `About`,
      description: `<p>Need to update your information? Fill out our Service Request Form, and we'll ensure you receive the best possible support.</p>`,
    },
    personalInfo: {
      title: `Personal Information`,
      description: 
      `
        <ul>
          <li className="mb-3">
            <strong>Residential or Mailing Address:</strong><br>
            Please provide your complete address for accurate service correspondence.
          </li>
          <li className="my-3">
            <strong>Contact Details:</strong><br>
            Share your preferred contact information so we can stay in touch.
          </li>
          <li className="mt-3">
            <strong>Employment Details:</strong><br>
            This helps us verify your identity and process your service requests efficiently.
          </li>
        </ul>
      `,
    },
    services: {
      title: `Select the service you need:`,
      description: 
      `
        <ul>
          <li className="mb-3">
            <strong>Account Statement Request:</strong><br>
            Request a detailed overview of your account activity.
          </li>
          <li className="my-3">
            <strong>Audit Confirmation:</strong><br>
            To obtain an official confirmation of your account details for audit purposes.
          </li>
          <li className="mt-3">
            <strong>Cheque Book Request:</strong><br>
            To order a new checkbook for your account.
          </li>
        </ul>
      `,
    },
    request: {
      title: `Submit Your Request`,
      description: `
      <div>
        <p>Once you've completed the form, please review your details carefully before submitting it to your nearest branch.</p>
        <p>If you're updating your mailing address, you can email your request to our Contact Centre, and our team will process it as soon as possible.</p>
      </div>
      `,
    },
  }
}